[
  { "code": "en", "label": "English", "flag": "🇬🇧", "hreflang": "en", "isDefault": true },
  { "code": "es", "label": "Español", "flag": "🇪🇸", "hreflang": "es", "isDefault": false },
  { "code": "fr", "label": "Français", "flag": "🇫🇷", "hreflang": "fr", "isDefault": false },
  { "code": "de", "label": "Deutsch", "flag": "🇩🇪", "hreflang": "de", "isDefault": false },
  { "code": "pt", "label": "Português", "flag": "🇵🇹", "hreflang": "pt", "isDefault": false },
  { "code": "zh", "label": "中文", "flag": "🇨🇳", "hreflang": "zh", "isDefault": false },
  { "code": "ja", "label": "日本語", "flag": "🇯🇵", "hreflang": "ja", "isDefault": false },
  { "code": "ru", "label": "Русский", "flag": "🇷🇺", "hreflang": "ru", "isDefault": false },
  { "code": "ar", "label": "العربية", "flag": "🌐", "hreflang": "ar", "isDefault": false }
]
